export function generateWorkgroupCentralSelectItem(wgId, centralId = null) {
  let composedId = wgId;
  if (centralId !== null) {
    composedId = `${wgId}-${centralId}`;
    return { wgId, centralId, composedId };
  }
  return { wgId, composedId };
}
